import React, { useState } from "react";
import './ElevatorInfoPopup.css';
import CloseImg from "../../assets/close-white.png";
import CloseImg2 from "../../assets/close-black.png";
import Info from "../../assets/info2.png";

const ElevatorInfoPopup = ({ device, onClose }) => {
    console.log("Elevator Info Popup called: ", device);
    const [showStatusInfo, setShowStatusInfo] = useState(false);

    const showStatusName = (statusCode) => {
        if (statusCode === 10) {
            return "Offline";
        } else if (statusCode === 20) {
            return "Running";
        } else if (statusCode === 30) {
            return "Guarded";
        } else if (statusCode === 40) {
            return "Alarm";
        } else if (statusCode === 50) {
            return "Emergency";
        } else if (statusCode === 60) {
            return "Shutdown";
        }
    };

    const statusInfoPopupContent = (statusCode) => {
        if (statusCode === 10) {
            return "Offline";
        } else if (statusCode === 20) {
            return "Running";
        } else if (statusCode === 30) {
            return (<div className="popup-info-text">
                <p>When an elevator status is "guarded", it typically indicates that there is an issue or malfunction with the elevator system that requires attention. Here are some common elevator problems and their potential solutions:</p>
                <p>1. The elevator won't move:</p>
                <ul>
                    <li>Check for power outages: Ensure your home has electricity, and the elevator's dedicated circuit breaker hasn't tripped.</li>
                    <li>Inspect the door sensors: Make sure all doors are properly closed, and their safety sensors are unobstructed.</li>
                    <li>Examine the call buttons: Verify that the buttons are functioning and haven't become stuck.</li>
                    <li><u>If none of the above resolves the issue, use the emergency call button to contact supporti.</u></li>
                </ul>
                <p>1. The elevator jerks or makes unusual</p>
                <ul>
                    <li>Clean the tracks and rollers: Dirt and debris can cause jerky movements. Use a soft cloth and appropriate cleaning products to remove grime.</li>
                    <li>Lubricate moving parts: Consult your manual for designated</li>
                </ul>
            </div>);
        } else if (statusCode === 40) {
            return "Alarm";
        } else if (statusCode === 50) {
            return "Emergency";
        } else if (statusCode === 60) {
            return "Shutdown";
        }
    };

    const closePopup = () => {
        console.log("cloase popup called");

        setShowStatusInfo(false);
    };

    return (
        <>
            <div className="elevator-info-container">
                <div className="status-info-heading"><span>Elevator {device.deviceName}</span> <img src={CloseImg2} className="close-status-info" onClick={onClose} /></div>
                <ul className="info-list">
                    <li>Current floor: {device.infoMessage.location}</li>
                    <li>Door: {device.infoMessage.door === 10 ? "Opening" : "Closing"}</li>
                    <li>Temperature: {device.infoMessage.temperature}</li>
                    <li>Status: <u className="status-code" onClick={() => setShowStatusInfo(true)}>{showStatusName(device.status)}</u><img src={Info} className="info-icon" onClick={closePopup} /></li>
                </ul>
            </div>

            {showStatusInfo && (
                <div className="popup-overlay" onClick={closePopup}>
                    <div className="status-info-popup" onClick={(e) => e.stopPropagation()}>
                        <div className="status-info-popup-heading"><span>Elevator Status: {showStatusName(device.status)}</span> <img src={CloseImg} className="close-popup" onClick={closePopup} /></div>

                        <div className="popup-info-text-container">{statusInfoPopupContent(device.status)}</div>
                    </div>
                </div >
            )}
        </>
    );
};

export default ElevatorInfoPopup;
